import { gql } from '@apollo/client';

export const searchAmendments = gql`
  query searchAmendments(
    $policyID: String!
    $keyword: String!
    $pageNumber: Int!
    $pageSize: Int!
    $orderAttribute: String!
    $orderDescending: Boolean!
  ) {
    production {
      searchAmendments(
        policyID: $policyID
        keyword: $keyword
        pagination: { pageNumber: $pageNumber, pageSize: $pageSize }
        orderBy: { attribute: $orderAttribute, descending: $orderDescending }
      ) {
        items {
          id
          referenceNumber
          amendmentType
          amendmentSubTypeID
          amendmentEffectiveDate
          status
          createdOn
          amendmentSubType {
            title
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getAmendmentDetails = gql`
  query GetAmendmentDetails($amendmentId: String!) {
    production {
      getAmendmentDetails(amendmentId: $amendmentId) {
        status
        amendmentAmendmentDetails {
          amendmentEffectiveDate
          amendmentIssueDate
          amendmentType
          amendmentSubType {
            code
            createdOn
            id
            modifiedOn
            title
          }
          amendmentReason
        }
        costAndChargesDetails {
          amendmentCost
          chargesPercentage
          currentChargesPercentage
          currentTPAFees
          tpaFees
        }
        policyDetails {
          policyEffectiveDate
          policyExpiryDate
          policyType
          currency {
            code
            createdOn
            id
            modifiedOn
            status
            symbol
            title
            titleAr
          }
          plan {
            beneficiaryMaxNumber
          }
        }
        summaryDetails {
          createdBy
          createdOn
          insuredMaxNumber
          line
          lineId
          lineCode
          mainBusinessPartner
          mainBusinessPartnerId
          modifiedBy
          modifiedOn
          plan
          planId
          policyId
          policyNumber
          referenceNumber
          relatedCompany
          relatedCompanyId
          subline
          sublineId
          user
          userId
          clauseText
        }

        amendmentPolicyQuoteDetails {
          basicToPolicyRate
          fixedStampToBasicRate
          fixedStampToPolicyRate
          planToBasicRate
          planToPolicyRate
          policyToSecondaryRate
        }

        policyCovers {
          id
          additiveSumInsured
          coverEffectiveFrom
          coverEffectiveTo
          excess
          excessType
          isMain
          isMandatory
          isNew
          isRemoved
          newExcess
          newPremiumAmount
          newPremiumPercentage
          newSumInsured
          policyCover
          policyCoverId
          policyEffectiveDate
          policyExpiryDate
          premiumAmount
          premiumVariance
          premiumPercentage
          premiumType
          sumInsured
          currency {
            code
            createdOn
            id
            modifiedOn
            status
            symbol
            title
            titleAr
          }
          isEditable
          coverEffectiveFromVariance
          coverEffectiveToVariance
        }

        currentOfferDetails {
          basicPremium
          charges
          coverage
          createdOn
          fixedStamp
          grossPremium
          municipalityTax
          netPremium
          policyCost
          proportionalStamp
          status
          sumInsured
          totalPremium
          tpaFees
          currency {
            code
            createdOn
            id
            modifiedOn
            status
            symbol
            title
            titleAr
          }
        }

        offerDetails {
          basicPremium
          charges
          coverage
          createdOn
          fixedStamp
          grossPremium
          municipalityTax
          netPremium
          policyCost
          proportionalStamp
          status
          sumInsured
          totalPremium
          tpaFees
          currency {
            code
            createdOn
            id
            modifiedOn
            status
            symbol
            title
            titleAr
          }
        }

        policyQuoteVariance {
          basicPremium
          charges
          coverage
          createdOn
          fixedStamp
          grossPremium
          municipalityTax
          netPremium
          policyCost
          proportionalStamp
          sumInsured
          totalPremium
          tpaFees
          currency {
            code
            createdOn
            id
            modifiedOn
            status
            symbol
            title
            titleAr
          }
        }

        policyPersons {
          id
          type
          code
          fullName
          addressId
          city
          limitCover
          personId
          order
          beneficiaryPercentage
          country {
            id
            code
            title
            createdOn
            modifiedOn
          }
        }
        documents {
          documentId
          documentName
          documentPath
          documentType
        }

        certificateAmendment {
          id
          status
          summaryDetails {
            policyId
            policyNumber
          }
          amendmentAmendmentDetails {
            amendmentEffectiveDate
            amendmentIssueDate
            amendmentReason
            amendmentType
          }
          costAndChargesDetails {
            amendmentCost
            chargesPercentage
            currentChargesPercentage
            currentTPAFees
            tpaFees
          }
          amendmentPolicyQuoteDetails {
            basicToPolicyRate
            fixedStampToBasicRate
            fixedStampToPolicyRate
            planToBasicRate
            planToPolicyRate
            policyToSecondaryRate
          }
          policyDetails {
            policyEffectiveDate
            policyExpiryDate
            currency {
              code
              createdOn
              id
              modifiedOn
              status
              symbol
              title
              titleAr
            }
          }
          policyCovers {
            additiveSumInsured
            coverEffectiveFrom
            coverEffectiveFromVariance
            coverEffectiveTo
            coverEffectiveToVariance
            excess
            excessType
            id
            isEditable
            isMain
            isMandatory
            isNew
            isRemoved
            newExcess
            newPremiumAmount
            newPremiumPercentage
            newSumInsured
            policyCover
            policyCoverId
            policyEffectiveDate
            policyExpiryDate
            premiumAmount
            premiumPercentage
            premiumType
            premiumVariance
            sumInsured
            currency {
              code
              createdOn
              id
              modifiedOn
              status
              symbol
              title
              titleAr
            }
          }
          policyPersons {
            id
            type
            code
            fullName
            addressId
            city
            limitCover
            personId
            order
            relation
            age
            beneficiaryPercentage
            country {
              id
              code
              title
              createdOn
              modifiedOn
            }
          }
          currentOfferDetails {
            basicPremium
            charges
            coverage
            createdOn
            fixedStamp
            grossPremium
            municipalityTax
            netPremium
            policyCost
            proportionalStamp
            status
            sumInsured
            totalPremium
            tpaFees
            currency {
              code
              createdOn
              id
              modifiedOn
              status
              symbol
              title
              titleAr
            }
          }
          offerDetails {
            basicPremium
            charges
            coverage
            createdOn
            fixedStamp
            grossPremium
            municipalityTax
            netPremium
            policyCost
            proportionalStamp
            status
            sumInsured
            totalPremium
            tpaFees
            currency {
              code
              createdOn
              id
              modifiedOn
              status
              symbol
              title
              titleAr
            }
          }
          policyQuoteVariance {
            basicPremium
            charges
            coverage
            createdOn
            fixedStamp
            grossPremium
            municipalityTax
            netPremium
            policyCost
            proportionalStamp
            sumInsured
            totalPremium
            tpaFees
            currency {
              code
              createdOn
              id
              modifiedOn
              status
              symbol
              title
              titleAr
            }
          }
        }
      }
    }
  }
`;

export const getAmendmentMoreDetails = gql`
  query GetAmendmentDetails($amendmentId: String!, $medicalAmendmentId: String!) {
    production {
      getAmendmentPolicyBankersBlanketBondsDetails(amendmentID: $amendmentId) {
        id
        policyID
        policyVersion
        policyVersionState
        proposalID
        branchName
        isMain
        isAgency
        employeeNumber
        underwritingYear
        infedility
        burglary
        holdup
        inSafe
        inTransit
        forgedCheques
        counterfeitCurrencies
        clause6
        falsification
        createdBy
        createdOn
        modifiedBy
        modifiedOn
      }
      getAmendmentPolicyMarine(amendmentID: $amendmentId) {
        id
        policyID
        policyVersion
        policyVersionState
        proposalID

        matter {
          id
          code
          title
          createdOn
          modifiedOn
        }
        matterID

        description
        vessalName
        vessalAge

        departureFrom
        departureTo

        transportationVia
        survey
        cargoContract
        bank

        sumPerShipmentCurrencyID
        sumPerShipmentCurrency {
          id
          code
          status
          symbol
          title
          titleAr
          createdOn
          modifiedOn
        }
        sumPerShipment
        sumPerShipmentPolicyCurrency
        sumPerShipmentRate

        lcNumber
        lcIssueDate
        claimsPayableBy
        loading
        remarks

        createdBy
        createdOn
        modifiedBy
        modifiedOn
      }
      getAmendmentPolicyMarineHull(amendmentID: $amendmentId) {
        id
        policyID
        policyVersion
        policyVersionState
        proposalID

        vesselName
        connectionPort
        territorialWaters

        usage
        builder
        constructionYear
        registryPort
        length
        weight
        height

        engineType
        engineNumber
        engineYearBuilt
        engineHorsePower
        engineMaxDesignedSpeed
        engineFuel

        remarks

        createdBy
        createdOn
        modifiedBy
        modifiedOn
      }
      getAmendmentPolicyRiskDescription(amendmentID: $amendmentId) {
        id
        policyID
        order
        policyVersion
        policyVersionState
        proposalID
        riskDescription
        geoLocationID
        geoLocation {
          id
          code
          title
          createdOn
          modifiedOn
        }
        createdBy
        createdOn
        modifiedBy
        modifiedOn
      }
      getAmendmentPolicyProperty(amendmentID: $amendmentId) {
        id
        policyID
        policyVersion
        policyVersionState
        order
        proposalID
        riskDescription
        geoLocationID
        geoLocation {
          id
          code
          title
          createdOn
          modifiedOn
        }
        location
        planCoverPropertyDetails {
          planCoverID
          riskRate
          sumInsured
          premium
        }
        createdBy
        createdOn
        modifiedBy
        modifiedOn
      }
      getAmendmentPolicyExpatDetails(amendmentID: $amendmentId) {
        barcodeFullCode
        barcodeNumber
        continuity
        continuityNumber
        dateOfBirth
        emergency
        exclusion
        gender
        id
        medicalClassID
        nationalityID
        occupationClassID
        policyID
        policyVersion
        policyVersionState
        proposalID
        remarks
      }
      getAmendmentPolicyMedical(amendmentId: $medicalAmendmentId) {
        id
        medicalClassId
        medicalClass {
          abbreviation
          code
          id
          title
        }
        levelId
        level {
          code
          id
          title
        }
        nssf
        policyID
        policyVersion
        policyVersionState
        grLimitDays
        numberOfAdherent
      }
      getAmendmentPolicyPersons(amendmentID: $medicalAmendmentId) {
        id
        personID
        personAddressID
        isPrincipal
        isNew
        isRemoved
        cardNumber
        continuity
        tpaReference1
        tpaReference2
        grApplicable
        exclusions
        relation
        remarks
        person {
          code
          fullName
          type
          dateOfBirth
          passportNumber
        }
        personAddress {
          id
          address {
            street
            city
            country
          }
          country {
            id
            title
          }
          zone {
            id
            title
          }
        }
        policyID
        policyVersion
        policyVersionState
      }
      getAmendmentPolicyMotor(amendmentID: $amendmentId) {
        id
        policyID
        proposalID
        vehicleID
        nameOnLicenseEN
        nameOnLicenseAR
        vignetteCode
        vignette
        agencyRepairYears
        depreciationYears
        acalCategoryID
        vehicle {
          id
          plateNumber
          yearOfMake
          engine
          chassis
          horsePower
          seatingCapacity
          weight
          engineSize
          carValue
          plateCode {
            id
            code
            title
          }
          usageType {
            id
            code
            title
          }
          bodyType {
            id
            code
            title
          }
          engineType {
            id
            code
            title
          }
          make {
            id
            code
            title
          }
          model {
            id
            code
            title
          }
          color {
            id
            code
            title
          }
        }
      }
      getAmendmentPolicyTravel(amendmentID: $amendmentId) {
        id
        policyVersion
        policyVersionState
        departure {
          id
          code
          title
        }
        departureId
        destination {
          id
          code
          title
          createdOn
          modifiedOn
        }
        destinationId
        duration
        numberOfAdherent
        createdBy
        createdOn
        modifiedBy
        modifiedOn
      }
    }
  }
`;

export const getAmendmentSubTypes = gql`
  query getAmendmentSubTypes {
    production {
      getAmendmentSubTypes {
        id
        code
        title
        createdOn
        modifiedOn
      }
    }
  }
`;

export const getAmendmentMarineLovs = gql`
  query getAmendmentMarineLovs {
    core {
      getCurrencies {
        id
        code
        title
        symbol
      }
    }
    production {
      getMatters {
        id
        code
        title
      }
    }
  }
`;

export const getAmendmentExpatLovs = gql`
  query getAmendmentExpatLovs {
    planConfig {
      getMedicalClasses {
        id
        code
        title
      }
    }
  }
`;

export const getDestinationsLookup = gql`
  query GetDestinationsLookup {
    planConfig {
      getDestinationsLookup {
        id
        code
        title
      }
    }
  }
`;

export const getGeoLocations = gql`
  query getGeoLocations {
    production {
      getGeoLocations {
        id
        code
        title
      }
    }
  }
`;

export const getSystemReferenceDateQuery = gql`
  query getSystemReferenceDate {
    core {
      getSystemReferenceDate
    }
  }
`;

export const getAmendmentsList = gql`
  query searchAmendments(
    $pagination: PaginationInput!
    $policyID: String
    $keyword: String
    $orderBy: OrderByInput
    $checkAccess: Boolean
    $types: [String!]
    $subTypes: [String!]
    $lines: [String!]
    $businessPartners: [String!]
    $statuses: [String!]
    $issueOnStart: DateTime
    $issueOnEnd: DateTime
    $effectiveOnStart: DateTime
    $effectiveOnEnd: DateTime
    $createdOnStart: DateTime
    $createdOnEnd: DateTime
  ) {
    production {
      searchAmendments(
        policyID: $policyID
        keyword: $keyword
        pagination: $pagination
        orderBy: $orderBy
        checkAccess: $checkAccess
        types: $types
        subTypes: $subTypes
        lines: $lines
        businessPartners: $businessPartners
        statuses: $statuses
        issueOnStart: $issueOnStart
        issueOnEnd: $issueOnEnd
        effectiveOnStart: $effectiveOnStart
        effectiveOnEnd: $effectiveOnEnd
        createdOnStart: $createdOnStart
        createdOnEnd: $createdOnEnd
      ) {
        items {
          id
          referenceNumber
          amendmentType
          amendmentSubTypeID
          amendmentIssueDate
          amendmentEffectiveDate
          amendedExpiryDate
          amendmentLineNumber
          amendmentActiveDays
          amendmentDurationRatio
          policyTerms
          status
          createdOn
          modifiedOn
          policyID
          amendmentSubType {
            id
            code
            title
            createdOn
            modifiedOn
          }
          policy {
            id
            policyNumber
            lineID
            createdBy
            createdOn
            policyStatus
            policyIssueDate
            policyEffectiveDate
            policyExpiryDate
            userID
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;
export const getMedicalClasses = gql`
  query GetMedicalClasses {
    planConfig {
      getMedicalClasses {
        abbreviation
        code
        createdOn
        id
        modifiedOn
        title
      }
    }
  }
`;

export const getMedicalLevels = gql`
  query GetMedicalLevels {
    planConfig {
      getMedicalLevels {
        code
        createdOn
        id
        modifiedOn
        title
      }
    }
  }
`;

export const getAmendmentFilters = gql`
  query getAmendmentFilters {
    production {
      getProposalLines {
        id
        code
        name
      }
      getProposalBusinessPartners {
        id
        code
        fullName
      }
      getAmendmentSubTypes {
        id
        code
        title
        createdOn
        modifiedOn
      }
    }
    AmendmentTypeList: __type(name: "AmendmentTypeList") {
      enumValues {
        name
      }
    }
    AmendmentStatusList: __type(name: "AmendmentStatusList") {
      enumValues {
        name
      }
    }
  }
`;
export const getPolicyMedicalCovers = gql`
  query GetPolicyMedicalCovers(
    $planID: String!
    $keyword: String
    $pagination: PaginationInput
    $orderBy: OrderByInput
  ) {
    planConfig {
      getPolicyMedicalCovers(
        planID: $planID
        keyword: $keyword
        pagination: $pagination
        orderBy: $orderBy
      ) {
        items {
          abbreviation
          abbreviationArabic
          code
          createdBy
          createdOn
          description
          id
          lineID
          modifiedBy
          modifiedOn
          name
          nameArabic
          printingOrder
          treatyID
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;
export const getPolicyTravelCovers = gql`
  query GetPolicyTravelCovers(
    $planID: String!
    $keyword: String
    $pagination: PaginationInput
    $orderBy: OrderByInput
  ) {
    planConfig {
      getPolicyTravelCovers(
        planID: $planID
        keyword: $keyword
        pagination: $pagination
        orderBy: $orderBy
      ) {
        items {
          abbreviation
          abbreviationArabic
          code
          createdBy
          createdOn
          description
          id
          lineID
          modifiedBy
          modifiedOn
          name
          nameArabic
          printingOrder
          treatyID
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;
export const getAmendmentClauses = gql`
  query getAmendmentClauses(
    $lines: [String!]
    $pagination: PaginationInput!
    $statuses: [String!]
  ) {
    planConfig {
      getClauses(lines: $lines, pagination: $pagination, statuses: $statuses) {
        items {
          id
          code
          createdOn
          modifiedOn
          name
          description
          line {
            id
            name
            status
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getInsuredDetailsLovs = gql`
  query getInsuredDetailsLovs {
    core {
      getNationalities {
        id
        code
        title
      }
      getOccupationClass {
        id
        code
        title
      }
    }
  }
`;

export const getAmendmentPolicyBusinessPartners = gql`
  query getAmendmentPolicyBusinessPartners(
    $amendmentId: String!
    $orderBy: OrderByInput
    $keyword: String
  ) {
    production {
      getAmendmentPolicyBusinessPartners(
        amendmentId: $amendmentId
        orderBy: $orderBy
        keyword: $keyword
      ) {
        id
        businessPartnerID
        isPrimary
        type
        businessPartnerOverriden {
          code
          fullName
        }
        sharePercentage
        planCommissionAmount
        planCommissionRate
        planCommissionType
        commissionAmount
        policyShareCommissionAmount
        taxOnCommission
        taxOnCommissionAmount
        businessPartner {
          id
          fullName
        }
        planCommissionApplicableOn {
          id
          title
        }
        planCommissionCurrency {
          id
          symbol
        }
      }
    }
  }
`;

export const getPolicyBusinessPartnerVariance = gql`
  query getPolicyBusinessPartnerVariance(
    $amendmentId: String!
    $orderBy: OrderByInput
    $keyword: String
  ) {
    production {
      getPolicyBusinessPartnerVariance(
        amendmentID: $amendmentId
        orderBy: $orderBy
        keyword: $keyword
      ) {
        id
        businessPartnerID
        policyBusinessPartner {
          type
          isPrimary
          sharePercentage
          planCommissionAmount
          planCommissionApplicableOn {
            id
            title
          }
          businessPartner {
            fullName
            type
          }
          planCommissionType
          planCommissionRate
          planCommissionCurrency {
            id
            symbol
          }
          businessPartnerOverriden {
            code
          }
        }
        commissionAmount
        policyShareCommissionAmount
        taxOnCommission
        taxOnCommissionAmount
        businessPartner {
          id
          fullName
        }
      }
    }
  }
`;

export const getAmendmentMedicalInsuredsLovs = gql`
  query getAmendmentMedicalInsuredsLovs {
    RelationsList: __type(name: "RelationsList") {
      enumValues {
        name
      }
    }

    ContinuityList: __type(name: "ContinuityList") {
      enumValues {
        name
      }
    }
  }
`;

export const getAmendmentPremiumDetails = gql`
  query getAmendmentPremiumDetails(
    $amendmentId: String!
    $pagination: PaginationInput!
    $keyword: String
    $orderBy: OrderByInput!
  ) {
    production {
      getAmendmentInsuredPolicyQuoteMedicalGroupByPolicyPerson(
        amendmentId: $amendmentId
        pagination: $pagination
        keyword: $keyword
        orderBy: $orderBy
      ) {
        items {
          sumInsured
          age
          netPremium
          charges
          tpaFees
          grossPremium
          proportionalStamps
          municipalityTax
          totalPremium
          policyPerson {
            isNew
            isRemoved
            person {
              code
              fullName
            }
            relation
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getAmendmentGroupMedicalPremiumDetails = gql`
  query getAmendmentGroupMedicalPremiumDetails(
    $amendmentId: String!
    $pagination: PaginationInput!
    $keyword: String
    $orderBy: OrderByInput!
  ) {
    production {
      getAmendmentGroupPolicyInsuredPolicyQuoteMedical(
        amednmentId: $amendmentId
        pagination: $pagination
        keyword: $keyword
        orderBy: $orderBy
      ) {
        items {
          insured
          numberOfAdherent
          class
          level
          coNssf
          sumInsured
          netPremium
          charges
          tpaFees
          grossPremium
          proportionalStamp
          municipalityTax
          totalPremium
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const downloadAmendmentMedicalPremiumDetails = gql`
  query downloadAmendmentInsuredPolicyQuoteMedical($amendmentId: String!) {
    production {
      downloadAmendmentInsuredPolicyQuoteMedical(amendmentId: $amendmentId) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const downloadAmendmentGroupMedicalPremiumDetails = gql`
  query downloadAmendmentGroupProlicyInsuredPolicyQuoteMedical(
    $amendmentId: String!
  ) {
    production {
      downloadAmendmentGroupProlicyInsuredPolicyQuoteMedical(
        amednmentId: $amendmentId
      ) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const downloadAmendmentTravelPremiumDetails = gql`
  query downloadAmendmentInsuredPolicyQuoteTravel($amendmentId: String!) {
    production {
      downloadAmendmentInsuredPolicyQuoteTravel(amendmentId: $amendmentId) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const getAmendmentPremiumDetailsTravel = gql`
  query getAmendmentPremiumDetailsTravel(
    $amendmentId: String!
    $pagination: PaginationInput!
    $keyword: String
    $orderBy: OrderByInput!
  ) {
    production {
      getAmendmentInsuredPolicyQuoteTravelGroupByPolicyPerson(
        amendmentId: $amendmentId
        pagination: $pagination
        keyword: $keyword
        orderBy: $orderBy
      ) {
        items {
          age
          charges
          grossPremium
          municipalityTax
          netPremium
          proportionalStamps
          sumInsured
          totalPremium
          tpaFees
          policyPerson {
            assignedToBusinessPartnerID
            beneficiaryPercentage
            cardNumber
            continuity
            coverLimit
            createdBy
            createdOn
            exclusions
            grApplicable
            grLimitDays
            groupPolicyID
            groupProposalID
            id
            isNew
            isPrincipal
            isRemoved
            linkedBusinessPartnerID
            modifiedBy
            modifiedOn
            order
            personAddressID
            personID
            policyID
            policyVersion
            policyVersionState
            proposalID
            relation
            remarks
            tpaReference1
            tpaReference2
            typeList
            person {
              code
              fullName
            }
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getAmendmentCancellationInsuredDetails = gql`
  query getAmendmentInsuredDetails(
    $amendmentId: String!
    $policyId: String!
    $pagination: PaginationInput!
    $keyword: String
    $orderBy: OrderByInput!
  ) {
    production {
      getAmendmentInsuredDetails(
        amendmentID: $amendmentId
        policyID: $policyId
        pagination: $pagination
        keyword: $keyword
        orderBy: $orderBy
      ) {
        items {
          policyPlanCoverId
          policyPersonId
          insuredName
          relation
          age
          cover
          sumInsured
          netPremium
          netPremiumVariance
          charges
          chargesVariance
          tpaFees
          tpaFeesVariance
          grossPremium
          grossPremiumVariance
          totalPremium
          totalPremiumVariance
          insuredPPCoverPeriod
          cancelledPeriod
          activeDays
          policyPlanCoverId
          policyPersonId
          id
          proportionalStampRate
          municipalityTaxRate
          coverProportionalStamp
          coverMunicipalityTax
          policyNumber
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;

export const getAmendmentEndorsementInsuredDetails = gql`
  query getAmendmentEndorsementInsuredDetails(
    $amendmentId: String!
    $policyId: String!
    $pagination: PaginationInput!
    $keyword: String
    $orderBy: OrderByInput!
  ) {
    production {
      getAmendmentInsuredDetails(
        amendmentID: $amendmentId
        policyID: $policyId
        pagination: $pagination
        keyword: $keyword
        orderBy: $orderBy
      ) {
        items {
          activeDays
          age
          cancelledPeriod
          charges
          chargesVariance
          cover
          coverMunicipalityTax
          coverProportionalStamp
          grossPremium
          grossPremiumVariance
          id
          insuredName
          insuredPPCoverPeriod
          municipalityTaxRate
          netPremium
          netPremiumVariance
          policyId
          policyNumber
          policyPersonId
          policyPlanCoverId
          proportionalStampRate
          relation
          status
          sumInsured
          totalPremium
          totalPremiumVariance
          tpaFees
          tpaFeesVariance
          currency {
            code
            createdOn
            id
            modifiedOn
            status
            symbol
            title
            titleAr
          }
        }
        paging {
          pageNumber
          pageSize
          totalCount
        }
      }
    }
  }
`;
